/**
 * batch-67 middelen-inname (FO-505 §C11, review B-I7) - de bezwaartermijn als
 * hele NL-kalenderdagen.
 *
 * "Bezwaar kan tot en met 21-10-2026" betekent tot het einde van die dag in
 * Nederland, niet tot het tijdstip waarop de termijn 14 x 24 uur na de melding
 * afloopt (dat zou om 15:12 op de laatste dag sluiten terwijl de portal "tot en
 * met" die dag belooft). De termijn begint op de NL-dag van de melding; de
 * laatste dag is die dag plus het aantal dagen.
 */
import { amsterdamAllDayStartToUtc } from './amsterdam-tijd'
import { formatDagDatum, vandaagAmsterdam } from './dagtaken-datum'
import { plusDagenYmd } from './telefonie'

/** De laatste dag waarop bezwaar kan (jjjj-mm-dd, NL-kalender). */
export function bezwaarLaatsteDag(start: Date, termijnDagen: number): string {
  return plusDagenYmd(formatDagDatum(vandaagAmsterdam(start)), Math.max(0, Math.trunc(termijnDagen)))
}

/** Het laatste moment waarop bezwaar kan: 23:59:59.999 Europe/Amsterdam op de laatste dag. */
export function bezwaarTotMoment(start: Date, termijnDagen: number): Date {
  const volgendeDag = plusDagenYmd(bezwaarLaatsteDag(start, termijnDagen), 1)
  return new Date(amsterdamAllDayStartToUtc(volgendeDag).getTime() - 1)
}
